import { render, staticRenderFns } from "./ComplaintDamageForm.vue?vue&type=template&id=04cccdb9&scoped=true"
import script from "./ComplaintDamageForm.vue?vue&type=script&lang=js"
export * from "./ComplaintDamageForm.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDamageForm.vue?vue&type=style&index=0&id=04cccdb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cccdb9",
  null
  
)

export default component.exports